module.exports = __webpack_public_path__ + "img/flag-AU.a5e7654a.png";